// Action Subject Ids

export const CREATE_APP = 'createApp';
export const SEARCH_APP = 'searchApp';
export const APP_LINK = 'appVersionsLink';
export const TOGGLE_DUAL_LICENSE = 'toggleDualLicense';
export const TOGGLE_CLOUD_MIGRATION_TRIAL = 'toggleCloudMigrationTrial';
export const PARTNER_DETAILS_FORM_INPUT = 'changePartnerDetailFormInput';
export const MANAGE_PARTNER_DETAILS_FORM = 'managePartnerDetailsForm';
export const EDIT_ICON = 'editIcon';
export const CHANGE_PARTNER_REPORTS_FILTER = 'changePartnerReportsFilter';
export const SEE_ALL_SUMMARY_CARDS = 'seeAllSummaryCards';
export const RESET_PARTNER_REPORTS_FILTER = 'resetPartnerReportsFilter';
export const OPEN_DATA_API_IN_NEW_TAB = 'openDataApiInNewTab';
export const CHANGE_PARTNER_AUDIT_LOGS_FILTER = 'changePartnerReportsFilter';
export const RESET_PARTNER_AUDIT_LOGS_FILTER = 'resetPartnerReportsFilter';
export const OPEN_REPORT_DETAILS_IN_NEW_TAB = 'openReportDetailsInNewTab';
export const OPEN_CONTACTS_EMAIL_LINK = 'openContactsEmailLink';
export const START_TOUR_ON_REPORTS = 'startTourOnReports';
export const DISMISS_TOUR_ON_REPORTS = 'dismissTourOnReports';
export const DISMISS_SPOTLIGHT_TOUR_ON_REPORTS = 'dismissNewReportsOnboardingTour';
export const OPEN_FEEDBACK_COLLECTOR_FOR_REPORTS = 'openFeedbackCollectorForReports';
export const SEND_FEEDBACK_FOR_REPORTS = 'sendFeedbackForReports';
export const DISABLE_NEW_REPORTS = 'disableNewReports';
export const EXPAND_ROW = 'expandRow';
export const EXPORT_REPORT = 'exportReport';
export const EXPORT_REPORT_DROPDOWN_CLICK = 'downloadReport';
export const CLICKED_ADDITIONAL_INSIGHTS = 'clickedAdditionalInsights';
export const SUBMIT_PARTNER_CONTACT_INFO_FORM = 'submitPartnerContactInfoForm';
export const CANCEL_PARTNER_CONTACT_INFO_FORM = 'cancelPartnerContactInfoForm';
export const SUBMIT_ABOUT_PARTNER_FORM = 'submitAboutPartnerForm';
export const SUBMIT_HOURS_OF_OPERATION_FORM = 'submitHoursOfOperationForm';
export const CANCEL_HOURS_OF_OPERATION_FORM = 'cancelHoursOfOperationForm';
export const CANCEL_ABOUT_PARTNER_FORM = 'cancelAboutPartnerForm';
export const SUBMIT_SUPPORT_CHANNELS_FORM = 'submitSupportChannelsForm';
export const CANCEL_SUPPORT_CHANNELS_FORM = 'cancelSupportChannelsForm';

// Contacts
export const ADD_PARTNER_CONTACT = 'addPartnerContact';
export const REMOVE_PARTNER_CONTACT = 'removePartnerContact';
export const MANAGE_PARTNER_CONTACTS_PERMISSION = 'managePartnerContactsPermission';
export const SUBMIT_PARTNER_CONTACTS_PERMISSION = 'submitManageContactsPermission';
export const CONTACTS_FILTERS = 'ContactsFilters';
export const CREATE_PROMOTION = 'createPromotion';
export const CHANGE_PROMOTION_INFO_FILTER = 'changePromotionInfoFilter';
export const SUBMIT_PARTNER_ADMIN_FORM = 'submitPartnerAdminForm';
export const REPORT_SECURITY_INCIDENT = 'reportSecurityIncident';
export const APPLY_SECURITY_SELF_ASSESSMENT = 'applySecuritySelfAssessment';
export const MANAGE_PARTNER_TAB = 'managePartnerTab';
export const NAVIGATE_PARTNER_REPORTING_TAB = 'navigateReportingTab';
export const PARTNER_REPORTS_MORE_FILTER = 'reportingMoreFilter';
export const PARTNER_REPORTS_PERIOD = 'reportingPeriod';
export const PARTNER_REPORTS_TEXT_SEARCH = 'reportingTextSearch';
export const PARTNER_REPORTS_EXPORT_CSV = 'reportingExportCsv';
export const PARTNER_REPORTS_EXPORT_JSON = 'reportingExportJson';
export const PARTNER_REPORTS_AGGREGATES_TAB = 'aggregateReportingTab';
export const PARTNER_REPORTS_AGGREGATE_GROUP_BY = 'aggregateReportingGroupBy';
export const PARTNER_REPORTS_SALES_UNIT_SELECTOR = 'reportingSalesUnit';
export const CHART_PATTERN_TOGGLE = 'chartPatternToggle';
export const FEEDBACK_BY_REASON_DROPDOWN = 'feedbackByReasonDropdown';
export const REPORTS_TITLE_INFO_ICON = 'reportTypeInformation';

// Manage Contact Events
export const ANALYTICS_SUBJECT_ID_ADD_CONTACT = 'addContact';
export const ANALYTICS_SUBJECT_ID_ADD_CONTACT_MODAL_TRIGGER = 'addContactModalTrigger';
export const ANALYTICS_SUBJECT_ID_MANAGE_CONTACT = 'manageContact';
export const ANALYTICS_SUBJECT_ID_SAVE_CONTACT_MODAL_TRIGGER = 'saveContactModalTrigger';
export const ANALYTICS_SUBJECT_ID_DELETE_CONTACT = 'deleteContact';
export const ANALYTICS_SUBJECT_ID_DELETE_NOW_CONTACT_MODAL_TRIGGER = 'deleteNowContactModalTrigger';
export const ANALYTICS_SUBJECT_ID_SELECT_CONTACT_FILTER = 'selectContactFilter';
// Event Containers

export const MANAGE_PARTNER_APPS_VIEW = 'managePartnerAppsView';
export const MANAGE_PARTNER_DETAILS_VIEW = 'managePartnerDetailsView';
export const MANAGE_PARTNER_CONTACTS_VIEW = 'managePartnerContactsView';
export const MANAGE_PARTNER_PROMOTION_VIEW = 'managePartnerPromotionView';
export const MANAGE_PARTNER_ADMIN_VIEW = 'managePartnerAdminView';
export const MANAGE_PARTNER_REPORTS_VIEW = 'managePartnerReportsView';
export const MANAGE_PARTNER_SECURITY_VIEW = 'managePartnerSecurityView';
export const MANAGE_PARTNER_AUDIT_LOGS_VIEW = 'managePartnerAuditLogsView';

// Promotions
export const ANALYTICS_SUBJECT_ID_CREATE_PROMOTION = 'createPromotion';
export const ANALYTICS_SUBJECT_ID_VIEW_PROMOTION_DETAILS = 'viewPromotionDetails';
export const ANALYTICS_SUBJECT_ID_PROMOTION_LIST_FILTER = 'promotionListFilters';
export const ANALYTICS_SUBJECT_ID_EDIT_PROMOTION = 'editPromotion';
export const ANALYTICS_SUBJECT_ID_SAVE_PROMOTION = 'savePromotion';
export const ANALYTICS_SUBJECT_ID_END_PROMOTION = 'endPromotion';
export const ANALYTICS_SUBJECT_ID_CREATE_PROMOTION_CODE = 'createPromotionCode';
export const ANALYTICS_SUBJECT_ID_DELETE_PROMOTION_CODE = 'deletePromotionCode';

// 2SV ANNOUNCEMENT BANNER
export const ANALYTICS_SUBJECT_ID_TWO_SV_ANNOUNCEMENT_BANNER = '2svAnnouncementBanner';
export const ANALYTICS_SUBJECT_ID_TWO_SV_ANNOUNCEMENT_BANNER_CLOSE = 'closeTwosvAnnouncementBanner';
export const ANALYTICS_SUBJECT_ID_TWO_SV_SESSION_TIMED_OUT_MODAL = '2svSessionTimedoutModal';
export const ANALYTICS_SUBJECT_ID_TWO_SV_ANNOUNCEMENT_MODAL = '2svAnnouncementModal';
export const ANALYTICS_SUBJECT_ID_TWO_SV_ANNOUNCEMENT_MODAL_CLOSE = 'closeTwosvSessionTimedoutModal';